import { Wrapper } from '@googlemaps/react-wrapper';
import ThemedIcon from '../../components/common/ThemedIcon';
import { useEffect, useRef, useState, useMemo } from 'react';
import React from 'react';
import { setKey, fromLatLng } from 'react-geocode';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useHistory, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Popper from '@mui/material/Popper';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import { withStyles } from '@material-ui/core/styles';
import { useJsApiLoader, GoogleMap } from '@react-google-maps/api';
import { useSelector } from 'react-redux';

import { editAddressMeds, fetchAddress } from '../../services';
import { debounce } from '../../utils';
import Header from '../../components/common/Header';
import LoadingComponent from '../../components/common/LoadingComponent';

import SearchIcon from '../../images/pharmacy/primary-search.svg';
import ClearIcon from '../../images/pharmacy/clear-location.svg';

const autocompleteService = { current: null };
setKey(process.env.REACT_APP_GOOGLE_API_KEY);

const LocationInputContainer = withStyles({
  root: {
    '&.MuiAutocomplete-popper': {
      width: 335,
    },
  },
  inputRoot: {
    '&&[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '&&[class*="MuiOutlinedInput-root"] $input': {
      padding: 0,
    },
  },
  input: {},
})(Autocomplete);

// Initialize with a default location (e.g., center of India) in case geolocation fails
let defaultLocation = {
  lat: 20.5937,
  lng: 78.9629,
};

const processGeocodeResponse = (response, setText) => {
  if (response && response.results && response.results.length > 0) {
    const address = response.results[0].formatted_address;
    const postalCode = response.results[0].address_components.filter((ele) =>
      ele.types.includes('postal_code')
    );
    const locality = response.results[0].address_components.filter((ele) =>
      ele.types.includes('locality')
    );

    setText({
      structured_formatting: {
        main_text: address,
        postalCode: postalCode.length > 0 ? postalCode[0].long_name : '',
        locality: locality.length > 0 ? locality[0].long_name : '',
      },
    });
  } else {
    setText('');
  }
};

const LocationSelect = ({ onLocationSelect, onClose }) => {
  const { lat, long } = useSelector((state) => state.user.locationInfo);

  const defaultLocation = {
    lat: lat || 20.5937,
    lng: long || 78.9629,
  };
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [map, setMap] = React.useState(null);
  const [marker, setMarker] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(defaultLocation);
  const [text, setText] = useState(null);

  const setMarkerPosition = () => {
    navigator.geolocation.getCurrentPosition((e) => {
      const bound = {
        lat: e.coords.latitude,
        lng: e.coords.longitude,
      };
      setCurrentLocation(bound);
      map.setCenter(bound);
      marker.setPosition(bound);
      map.setZoom(16);
      fromLatLng(bound.lat, bound.lng).then(
        (response) => {
          processGeocodeResponse(response, setText);
        },
        (error) => {
          console.error(error);
        }
      );
    });
  };

  const fetch = useMemo(
    () =>
      throttle((request, callback) => {
        autocompleteService.current.getPlacePredictions(request, callback);
      }, 200),
    []
  );

  useEffect(() => {
    let active = true;

    if (!autocompleteService.current && window.google?.maps?.places) {
      autocompleteService.current =
        new window.google.maps.places.AutocompleteService();
    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);

  const setLatLong = (placeId) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      {
        placeId,
      },
      function (responses, status) {
        if (status === 'OK') {
          let lat = responses[0].geometry.location.lat();
          let lng = responses[0].geometry.location.lng();
          const bound = {
            lat,
            lng,
          };
          setCurrentLocation(bound);
          map.setCenter(bound);
          marker.setPosition(bound);
          map.setZoom(14);
        }
      }
    );
  };

  return (
    <div className="h-full w-full bg-textbox relative rounded-t-12">
      <Header onTap={onClose} title="Choose location"></Header>
      {currentLocation && (
        <div
          className="absolute flex justify-between items-center"
          style={{
            top: '15%',
            left: '50%',
            transform: 'translate(-50%,0)',
            borderRadius: '10px',
            padding: '15px 8px 14px 16px',
            width: '335px',
            zIndex: '2',
            backgroundColor: 'white',
          }}
        >
          <div className="flex w-full" id="autocomplete-input">
            <ThemedIcon src={SearchIcon} alt="search" className="mr-12px" />
            <LocationInputContainer
              disablePortal
              open={showDropdown}
              forcePopupIcon={false}
              disableClearable
              getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.description
              }
              filterOptions={(x) => x}
              options={options}
              autoComplete
              includeInputInList
              filterSelectedOptions
              value={value}
              onChange={(event, newValue) => {
                setOptions(newValue ? [newValue, ...options] : options);
                if (newValue !== '') setText(newValue);
                setLatLong(newValue.place_id);
              }}
              onInputChange={debounce((event, newInputValue) => {
                setInputValue(newInputValue);
                if (newInputValue.length === 0) {
                  if (showDropdown) setShowDropdown(false);
                } else if (!showDropdown) setShowDropdown(true);
              }, 800)}
              onClose={() => setShowDropdown(false)}
              sx={{ width: '80%', '& fieldset': { border: 'none' }, zIndex: 2 }}
              renderInput={(params) => <TextField {...params} />}
              renderOption={(props, option) => {
                const matches =
                  option.structured_formatting.main_text_matched_substrings;
                const parts = parse(
                  option.structured_formatting.main_text,
                  matches.map((match) => [
                    match.offset,
                    match.offset + match.length,
                  ])
                );

                return (
                  <li {...props}>
                    <Grid container alignItems="center">
                      <Grid item xs className="z-20">
                        {parts.map((part, index) => {
                          return (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          );
                        })}

                        <Typography variant="body2" color="text.secondary">
                          {option.structured_formatting.secondary_text}
                        </Typography>
                      </Grid>
                    </Grid>
                  </li>
                );
              }}
            />
          </div>
          <img
            src={ClearIcon}
            alt="clear"
            className="cursor-pointer"
            onClick={() => {
              setOptions([]);
              setValue('');
            }}
          />
        </div>
      )}
      <Map
        map={map}
        setMap={setMap}
        marker={marker}
        setMarker={setMarker}
        currentLocation={currentLocation}
        setCurrentLocation={setCurrentLocation}
        setValue={setText}
      ></Map>
      {currentLocation && (
        <FooterCard
          lat={currentLocation ? currentLocation.lat : false}
          lng={currentLocation ? currentLocation.lng : false}
          value={text}
          setValue={setText}
          onGetLocation={setMarkerPosition}
          onLocationSelect={onLocationSelect}
          currentLocation={currentLocation}
        ></FooterCard>
      )}
    </div>
  );
};

const FooterCard = ({
  onGetLocation,
  value,
  setValue,
  lat,
  lng,
  onLocationSelect,
  currentLocation,
}) => {
  const history = useHistory();
  const location = useLocation();
  const user = useSelector((state) => state.user);

  const fetchAddressFromCoords = async () => {
    const res = await fetchAddress(lat, lng, user?.authToken);
    // pass correct key to fill in the address modal
    setValue((prev) => ({
      structured_formatting: {
        ...prev?.structured_formatting,
        postalCode: res?.result?.postalCode || '',
      },
    }));
  };

  useEffect(() => {
    fetchAddressFromCoords();
  }, [lat, lng]);

  return (
    <div className="w-full px-20px absolute bottom-5">
      <div className="w-full flex justify-end">
        <button
          className="bg-textbox p-8px rounded-full mb-10px"
          onClick={onGetLocation}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.4016 8.00156C10.4016 9.3271 9.32709 10.4016 8.00156 10.4016C6.67602 10.4016 5.60156 9.3271 5.60156 8.00156C5.60156 6.67602 6.67602 5.60156 8.00156 5.60156C9.32709 5.60156 10.4016 6.67602 10.4016 8.00156Z"
              fill="var(--primary-button)"
            />
            <path
              d="M16 7.2H14.2769C13.9077 4.36923 11.6308 2.09231 8.80001 1.72308V0H7.20001V1.72308C4.36923 2.09231 2.09231 4.36923 1.72308 7.2H0V8.8H1.72308C2.09231 11.6308 4.36923 13.9077 7.20001 14.2769V16H8.80001V14.2769C11.6308 13.9077 13.9077 11.6308 14.2769 8.8H16V7.2ZM8.00001 12.7385C5.41539 12.7385 3.26154 10.5846 3.26154 8C3.26154 5.41538 5.41539 3.26154 8.00001 3.26154C10.5846 3.26154 12.7385 5.41538 12.7385 8C12.7385 10.5846 10.5846 12.7385 8.00001 12.7385Z"
              fill="var(--primary-button)"
            />
          </svg>
        </button>
      </div>
      <div className="py-16x pb-2px rounded-12 bg-textbox">
        <div className="flex p-16px pb-8px items-start justify-between">
          <div className="mt-4px flex items-start">
            <svg
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.0003 8.35536C4.49583 8.35536 3.2754 7.18819 3.2754 5.74937C3.2754 4.31055 4.49583 3.14453 6.0003 3.14453C7.50476 3.14453 8.72519 4.31055 8.72519 5.74937C8.72519 7.18819 7.50476 8.35536 6.0003 8.35536ZM6.00027 0C5.94731 0 5.89435 0.00115106 5.8426 0.00230211C0.568537 0.110501 -1.95415 6.26865 1.77572 9.83462L5.44783 13.7816C5.75353 14.0728 6.247 14.0728 6.5515 13.7816L10.2248 9.83462C13.9535 6.26865 11.432 0.110501 6.15794 0.00230211C6.10498 0.00115106 6.05322 0 6.00027 0Z"
                fill="var(--primary-button)"
              />
            </svg>
            <div
              className="flex flex-col text-body-s ml-10px"
              style={{ width: '275px' }}
            >
              <p className="text-title-m font-semibold">
                {value ? value.structured_formatting.main_text : ''}
              </p>
              <p className="text-sub">
                {value ? value.structured_formatting.secondary_text : ''}
              </p>
            </div>
          </div>
        </div>
        <div className="m-20px">
          <button
            onClick={() => {
              onLocationSelect(lat, lng, value);
            }}
            className="w-full bg-primary flex justify-center text-body-m font-semibold text-textbox py-14px items-center rounded-12"
          >
            <div>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.81329 3.33073C6.32953 3.33073 3.50538 5.9424 3.50538 9.16406C3.50538 11.0025 4.70936 12.7207 6.39343 14.0704L9.4946 16.5559C9.6775 16.7025 9.94909 16.7025 10.132 16.5559L13.2332 14.0704C14.9172 12.7207 16.1212 11.0025 16.1212 9.16406C16.1212 5.9424 13.2971 3.33073 9.81329 3.33073ZM1.70312 9.16406C1.70312 5.02193 5.33417 1.66406 9.81329 1.66406C14.2924 1.66406 17.9235 5.02193 17.9235 9.16406C17.9235 11.6861 16.2926 13.8239 14.4135 15.3299L11.3123 17.8154C10.452 18.5049 9.17455 18.5049 8.31424 17.8154L5.21307 15.3299C3.33396 13.8239 1.70312 11.6861 1.70312 9.16406Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.156 9.75332C13.508 9.42788 13.508 8.90024 13.156 8.57481L11.3538 6.90814C11.0019 6.5827 10.4313 6.5827 10.0794 6.90814C9.72748 7.23358 9.72748 7.76121 10.0794 8.08665L10.3433 8.33073H7.11207C6.61439 8.33073 6.21094 8.70382 6.21094 9.16406C6.21094 9.6243 6.61439 9.99739 7.11207 9.99739H10.3433L10.0794 10.2415C9.72748 10.5669 9.72748 11.0945 10.0794 11.42C10.4313 11.7454 11.0019 11.7454 11.3538 11.42L13.156 9.75332Z"
                  fill="white"
                />
              </svg>
            </div>
            <p className="ml-8px">Confirm</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationSelect;

// import React from 'react';
// import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '100%',
};

const center = {
  lat: 0,
  lng: 0,
};

function Map({
  map,
  setMap,
  marker,
  setMarker,
  currentLocation,
  setCurrentLocation,
  setValue,
}) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries: ['places'],
  });
  const [loading, setLoading] = useState(true);
  const ref = useRef();
  const timeoutRef = useRef(null); // Ref to store timeout ID

  const onLoad = React.useCallback(function callback(map) {
    setLoading(true);
    // new window.google.maps.Map(ref.current, {});
    map.setZoom(16);
    map.setOptions({ disableDefaultUI: true });
    setMap(map);
    const markers = new window.google.maps.Marker({
      position: currentLocation,
      map: map,
    });
    setMarker(markers);

    // Define options for geolocation request
    const geoOptions = {
      enableHighAccuracy: true,
      timeout: 10000, // 10 seconds timeout
      maximumAge: 0,
    };
    // Success callback for geolocation
    const geoSuccess = (position, zoomLevel = 16) => {
      // Clear our safety timeout if we got a successful response
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }

      const bound = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      setCurrentLocation(bound);
      map.setCenter(bound);
      map.setZoom(zoomLevel);
      markers.setPosition(bound);
      fromLatLng(bound.lat, bound.lng).then(
        (response) => {
          processGeocodeResponse(response, setValue);
          setLoading(false);
        },
        (error) => {
          console.error('Geocode error:', error);
          setLoading(false); // Important - set loading to false even on error
        }
      );
    };

    // Error callback for geolocation
    const geoError = (error) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }

      console.error('Geolocation Error Details:', error);

      // if (errorMessage) alert(errorMessage);
      geoSuccess(
        {
          coords: {
            latitude: currentLocation.lat,
            longitude: currentLocation.lng,
          },
        },
        5
      );
    };
    if (!currentLocation.lat) {
      // Try to get user's location with proper error handling
      if (navigator.geolocation) {
        try {
          // Set up a safety timeout for when the permission prompt is dismissed without a response
          timeoutRef.current = setTimeout(() => {
            // If we reach this point, the user probably dismissed the prompt without responding
            geoSuccess(
              {
                coords: {
                  latitude: currentLocation.lat,
                  longitude: currentLocation.lng,
                },
              },
              5
            );
          }, 15000); // 15 seconds should be enough for the user to interact with the permission prompt

          navigator.geolocation.getCurrentPosition(
            geoSuccess,
            geoError,
            geoOptions
          );
        } catch (e) {
          console.error('Unexpected geolocation error:', e);
          // Force handle default location as a last resort
          geoSuccess(
            {
              coords: {
                latitude: currentLocation.lat,
                longitude: currentLocation.lng,
              },
            },
            5
          );
        }
      } else {
        console.error('Geolocation is not supported by this browser');
        alert(
          'Geolocation is not supported by your browser. Please use a modern browser.'
        );
        // Fall back to default location
        geoSuccess(
          {
            coords: {
              latitude: currentLocation.lat,
              longitude: currentLocation.lng,
            },
          },
          5
        );
      }
    } else {
      geoSuccess(
        {
          coords: {
            latitude: currentLocation.lat,
            longitude: currentLocation.lng,
          },
        },
        12
      );
    }
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  return isLoaded ? (
    <>
      <GoogleMap
        mapContainerStyle={!loading ? containerStyle : { display: 'none' }}
        center={center}
        onLoad={onLoad}
        onUnmount={onUnmount}
        onClick={(e) => {
          const lat = e.latLng?.lat();
          const lng = e.latLng?.lng();
          setCurrentLocation({
            lat,
            lng,
          });
          marker.setPosition({
            lat,
            lng,
          });
          fromLatLng(lat, lng).then(
            (response) => {
              console.log('RESPONSE', response);
              processGeocodeResponse(response, setValue);
            },
            (error) => {
              console.error(error);
            }
          );
        }}
        ref={ref}
        mapContainerClassName="cursor-pointer"
      >
        {/* Child components, such as markers, info windows, etc. */}
      </GoogleMap>
    </>
  ) : (
    <LoadingComponent />
  );
}
